/**
 * Part of ankecare project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import '@regenerator-runtime';
import '@unicorn/unicorn.js';
import { UIBootstrap5 } from '@unicorn/ui/ui-bootstrap5.js?1c4d7dc850209c8f5a3a9539';

u.use(UIBootstrap5);

export default u;

// Alertify
alertify.set('notifier', 'position', 'top-center');

u.notify = function (message, type = 'success', options = {}) {
  return alertify.notify(message, type, options.wait || 5, options.callback || null);
};

// Header menu
const menuItem = $('.c-menu').children('.nav-item');
const header = $('.c-header');

menuItem.on('mouseover', () => {
  if (!header.hasClass('c-bg-opacity')) {
    header.addClass('c-bg-opacity');
  }
});

menuItem.on('mouseleave', () => {
  if (header.hasClass('c-bg-opacity')) {
    header.removeClass('c-bg-opacity');
  }
});

// mobile menu
const mobileMenu = $('.c-mobile-menu');
const mobileMenuItem = mobileMenu.children('.c-mobile-menu__item');

mobileMenuItem.on('click', (e) => {
  let $this = $(e.target);

  if ($this.hasClass('collapsed')) {
    $this.children('i').removeClass('fa-angle-up');
    $this.children('i').addClass('fa-angle-down');
  } else {
    $this.children('i').removeClass('fa-angle-down');
    $this.children('i').addClass('fa-angle-up');
  }
});

// copy current url
$('.j-copy-link-btn').on('click', () => {
  navigator.clipboard.writeText(window.location.href);

  window.setTimeout(() => {
    alert('連結已複製');
  }, 300);
});

// blockquote add class
$('body').find('blockquote').addClass('c-mon-quote');

// 全站Carousel 共用 var
const advCarousel = $('.j-carousel');

advCarousel.on('initialized.owl.carousel', (e) => {
  addLog(e);
});

advCarousel.on('changed.owl.carousel', (e) => {
  addLog(e);
});

const dragCarousel = $('.j-drag-carousel').owlCarousel({
  items: 1,
  loop: true,
  autoplay: true,
  autoplayTimeout: 10000,
  dots: true,
  nav: false,
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  smartSpeed: 500,
});

const autoCarousel = $('.j-auto-carousel').owlCarousel({
  items: 1,
  loop: true,
  autoplay: true,
  autoplayTimeout: 10000,
  dots: false,
  nav: false,
  mouseDrag: false,
  touchDrag: false,
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  smartSpeed: 500,
});

const dotCarousel = $('.j-dot-carousel').owlCarousel({
  items: 1,
  loop: true,
  autoplay: true,
  autoplayTimeout: 10000,
  dots: true,
  nav: false,
  mouseDrag: false,
  touchDrag: false,
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  smartSpeed: 500,
});

function addLog(e) {
  const $this = $(e.currentTarget);
  const active = $this.find('.owl-item.active').find('img');
  const id = active.data('id');

  if (!active.length) {
    return;
  }

  u.$http.post(u.route('ajax_adv_log'), { id: id })
    .then(function (response) {

    })
    .catch(function (e) {
      console.error(e);
    });
}

function initCarousel(carousel) {
  carousel.owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 10000,
    dots: false,
    nav: false,
    mouseDrag: false,
    touchDrag: false,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    smartSpeed: 500,
  });
}

function webCarousel(carousel) {
  let width = window.innerWidth;

  if (width >= 768) {
    initCarousel(carousel);
  } else {
    carousel.trigger('destroy.owl.carousel');
  }
}

function mobileCarousel(carousel) {
  let width = window.innerWidth;

  if (width < 768) {
    initCarousel(carousel);
  } else {
    carousel.trigger('destroy.owl.carousel');
  }
}

$(window).on('resize', function () {
  webCarousel($('.j-web-carousel'));
  mobileCarousel($('.j-mobile-carousel'));
});

webCarousel($('.j-web-carousel'));
mobileCarousel($('.j-mobile-carousel'));
